import { Capacitor, registerPlugin } from "@capacitor/core";

type PreferredLanguageResult = {
  languageTag: string;
  /** Android 13+ only; omitted on iOS. */
  supportsPerAppLocale?: boolean;
};

export interface NativeSettingsPlugin {
  getPreferredLanguage(): Promise<PreferredLanguageResult>;
  openAppSettings(): Promise<void>;
}

const NativeSettings = registerPlugin<NativeSettingsPlugin>("NativeSettings");

export const isNativeSettingsAvailable = () =>
  Capacitor.isNativePlatform() &&
  (Capacitor.getPlatform() === "ios" || Capacitor.getPlatform() === "android") &&
  Capacitor.isPluginAvailable("NativeSettings");

export const canOpenNativeAppSettings = () =>
  Capacitor.isNativePlatform() && Capacitor.isPluginAvailable("NativeSettings");

export async function openNativeAppSettings() {
  if (!canOpenNativeAppSettings()) {
    throw new Error("App settings are unavailable in this environment.");
  }

  await NativeSettings.openAppSettings();
}

export { NativeSettings };
